import { render } from "./MarqueeAlert.vue?vue&type=template&id=6059f28b&ts=true"
import script from "./MarqueeAlert.vue?vue&type=script&lang=ts"
export * from "./MarqueeAlert.vue?vue&type=script&lang=ts"

import "./MarqueeAlert.vue?vue&type=style&index=0&id=6059f28b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__